import { Component } from '@angular/core';

@Component({
  selector: 'app-advanced-search',
  imports: [],
  templateUrl: './advanced-search.html',
  styleUrl: './advanced-search.scss',
})
export class AdvancedSearch {}
